// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  width: 100%;
  height: 100%;
}

.video-player-global {
  position: absolute;
  top: 0;
  left: 0;
}

.video-wrapper-global {
  position: absolute !important;
  padding: 0 !important;
  background-color: black;
}

.video-wrapper {
  position: relative;
  padding: 0;
}
.video-wrapper.floating {
  z-index: 999;
  bottom: 0;
  right: 0;
  margin: 15px;
}
.video-wrapper.floating .close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
}
.video-wrapper.floating .drag-handle {
  position: absolute;
  top: 10px;
  left: 10px;
}
.video-wrapper.integrated .close-btn {
  display: none;
}
.video-wrapper.integrated .drag-handle {
  display: none;
}
.video-wrapper.integrated .expand-btn {
  position: absolute;
  top: 10px;
  right: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/content/reusable_components/video-player/video-player.component.scss"],"names":[],"mappings":"AAAA;EACC,WAAA;EACA,YAAA;AACD;;AAEA;EACC,kBAAA;EACA,MAAA;EACA,OAAA;AACD;;AAEA;EACC,6BAAA;EACA,qBAAA;EACA,uBAAA;AACD;;AAEA;EACC,kBAAA;EACA,UAAA;AACD;AACC;EACC,YAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;AACF;AACE;EACC,kBAAA;EACA,SAAA;EACA,WAAA;AACH;AAEE;EACC,kBAAA;EACA,SAAA;EACA,UAAA;AAAH;AAKE;EACC,aAAA;AAHH;AAME;EACC,aAAA;AAJH;AAOE;EACC,kBAAA;EACA,SAAA;EACA,WAAA;AALH","sourcesContent":[":host {\n\twidth: 100%;\n\theight: 100%;\n}\n\n.video-player-global {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n}\n\n.video-wrapper-global {\n\tposition: absolute !important;\n\tpadding: 0 !important;\n\tbackground-color: black;\n}\n\n.video-wrapper {\n\tposition: relative;\n\tpadding: 0;\n\n\t&.floating {\n\t\tz-index: 999;\n\t\tbottom: 0;\n\t\tright: 0;\n\t\tmargin: 15px;\n\n\t\t.close-btn {\n\t\t\tposition: absolute;\n\t\t\ttop: 10px;\n\t\t\tright: 10px;\n\t\t}\n\n\t\t.drag-handle {\n\t\t\tposition: absolute;\n\t\t\ttop: 10px;\n\t\t\tleft: 10px;\n\t\t}\n\t}\n\n\t&.integrated {\n\t\t.close-btn {\n\t\t\tdisplay: none;\n\t\t}\n\n\t\t.drag-handle {\n\t\t\tdisplay: none;\n\t\t}\n\n\t\t.expand-btn {\n\t\t\tposition: absolute;\n\t\t\ttop: 10px;\n\t\t\tright: 10px;\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
